// Pro plan prices - monthly vs annual (billed yearly). Yearly runs on
// charm pricing (19/mo - the headline figure crosses the left-digit
// threshold); monthly stays a round 25 as the anchor that sells yearly.
// One definition: the pricing page and the home page's structured data
// (WebApplication offers) both read these.
export const PRO_PRICE_MONTHLY = 25;
export const PRO_PRICE_ANNUAL_PER_MONTH = 19;
export const PRO_PRICE_ANNUAL_TOTAL = PRO_PRICE_ANNUAL_PER_MONTH * 12;
